const INITIAL_STATE = {
  data: {},
  errors: {},
    
}
const addBlockDay = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'ADD_BLOCKDAY_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'ADD_BLOCKDAY_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default addBlockDay;